import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import moment from "moment"
import 'moment/locale/fr';

import { FirebaseProvider } from './services/Firebase'
import { AuthProvider } from './services/Session'
import ProtectedRoute from './components/ProtectedRoute'
import NoMatch from './pages/404'
import Login from './pages/Login'
import Home from './pages/Home'
import Interventions from './pages/Interventions'
import Intervention from './pages/Intervention'
import InterventionUpdate from './pages/InterventionUpdate'
import UserProfile from './pages/UserProfile'
import History from './pages/History'
import PublicStatus from './pages/PublicStatus'
import PublicFeedbacks from './pages/PublicFeedbacks';
import PublicAppointment from './pages/PublicAppointment';
import Appointments from './pages/Appointments'
import Appointment from './pages/Appointment'
import Landing from './pages/Landing'
import Pricing from './pages/Pricing'

moment.locale('fr')
const App = () => (
  <FirebaseProvider>
    <AuthProvider>
      <Router>
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route exact path="/pricing">
            <Pricing />
          </Route>
          <ProtectedRoute exact path="/app">
            <Home />
          </ProtectedRoute>
          <Route exact path="/login">
            <Login />
          </Route>
          <ProtectedRoute path="/app/interventions/:id/update">
            <InterventionUpdate />
          </ProtectedRoute>
          <ProtectedRoute path="/app/interventions/create">
            <Intervention />
          </ProtectedRoute>
          <ProtectedRoute path="/app/interventions/:id">
            <Intervention />
          </ProtectedRoute>
          <ProtectedRoute path="/app/interventions">
            <Interventions />
          </ProtectedRoute>
          <ProtectedRoute path="/app/appointments/create">
            <Appointment />
          </ProtectedRoute>
          <ProtectedRoute path="/app/appointments/:id">
            <Appointment />
          </ProtectedRoute>
          <ProtectedRoute path="/app/appointments">
            <Appointments />
          </ProtectedRoute>
          <ProtectedRoute path="/app/history">
            <History />
          </ProtectedRoute>
          <ProtectedRoute path="/app/profile">
            <UserProfile />
          </ProtectedRoute>
          <Route path="/status/:id">
            <PublicStatus />
          </Route>
          <Route path="/feedbacks/:id">
            <PublicFeedbacks />
          </Route>
          <Route path="/appointments/:id">
            <PublicAppointment />
          </Route>
          <Route path="*">
            <NoMatch />
          </Route>
        </Switch>
      </Router>
    </AuthProvider>
  </FirebaseProvider>
);

export default App;
